import type { ReactElement, FC } from 'react';

interface IProps {
    condition: boolean;
    errorComponent?: ReactElement | null;
}

export type IConditionalProps = IProps;

export const Conditional: FC<IProps> = ({
    condition = false,
    errorComponent = null,
    children,
}): ReactElement => {
    return (condition ? children : errorComponent) as ReactElement;
};
